﻿import * as React from 'react';
import { BaseResolver } from './base-resolver';

interface ResolverState {

}

export class Resolver_SpotColours extends BaseResolver {
    public id: "resolver_spotcolours";

    private state: ResolverState = {

    };

    public constructor(private svgRoot: SVGSVGElement) {
        super();

        this.component = (
            <Resolver_SpotColours_Element />
        );
    }

    public needResolution(): boolean {
        return false; // TODO: Implement
    }

    public resolveSvg(svgContainer: HTMLTemplateElement) {
        // TODO: Implement
    }

    private onUpdate(newValues: ResolverState | { [key: string]: any }) {
        this.state = {
            ...this.state,
            ...newValues
        }
    }
}

interface Props {

}

const Resolver_SpotColours_Element: React.FC<Props> = () => {
    return (
        <fieldset>
            <legend>Spot Colours</legend>
        </fieldset>
    );
}

